import React, { useState } from 'react'
import { useT } from './translations'

// options_prefill holds the text each choice fills in, at the same index
const OptionsEditor = ({ options, prefills, withPrefill, onChange, disabled }) => {
  const t = useT()
  const [draft, setDraft] = useState('')

  const list  = options || []
  const texts = prefills || []

  const update = (nextOptions, nextTexts) => onChange(nextOptions, withPrefill ? nextTexts : texts)

  const add = () => {
    const values = draft.split(';').map((value) => value.trim()).filter((value) => value && !list.includes(value))
    if (values.length === 0) { return }
    update([...list, ...values], [...texts, ...values.map(() => '')])
    setDraft('')
  }

  const move = (index, offset) => {
    const target = index + offset
    if (target < 0 || target >= list.length) { return }
    const nextOptions = [...list]
    const nextTexts = [...texts]
    ;[nextOptions[index], nextOptions[target]] = [nextOptions[target], nextOptions[index]]
    ;[nextTexts[index], nextTexts[target]] = [nextTexts[target], nextTexts[index]]
    update(nextOptions, nextTexts)
  }

  return (
    <div className="fb-options">
      {list.map((option, index) => (
        <div className="fb-option" key={index}>
          <span className="fb-option-index">{index + 1}</span>
          <div className="fb-option-fields">
            <input
              className="fb-input"
              value={option}
              disabled={disabled}
              onChange={(event) => update(list.map((value, position) => (position === index ? event.target.value : value)), texts)}
            />
            {withPrefill &&
              <input
                className="fb-input is-sub"
                value={texts[index] || ''}
                placeholder={t.prefill_text}
                disabled={disabled}
                onChange={(event) => {
                  const nextTexts = list.map((_, position) => (position === index ? event.target.value : texts[position] || ''))
                  update(list, nextTexts)
                }}
              />
            }
          </div>
          {!disabled &&
            <div className="fb-option-actions">
              <button type="button" title={t.move_up} onClick={() => move(index, -1)} disabled={index === 0}><i className="fas fa-arrow-up" /></button>
              <button type="button" title={t.delete} onClick={() => update(list.filter((_, position) => position !== index), texts.filter((_, position) => position !== index))}>
                <i className="fas fa-times" />
              </button>
            </div>
          }
        </div>
      ))}
      {!disabled &&
        <div className="fb-option-add">
          <input
            className="fb-input"
            value={draft}
            placeholder={t.add_option}
            onChange={(event) => setDraft(event.target.value)}
            onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); add() } }}
          />
          <button type="button" className="fb-button" onClick={add} disabled={!draft.trim()}><i className="fas fa-plus" /></button>
        </div>
      }
    </div>
  )
}

export default OptionsEditor
